import React from 'react';
import { NextPage } from 'next';
import { useRouter } from 'next/router';
import { Row } from '@sumup-oss/circuit-ui/legacy';

import SectionArticles from '../components/SectionArticles';

import { SectionPageProps } from 'types/components';
import SectionsList from 'components/SectionsList';
import MobileSectionsList from 'components/MobileSectionsList';
import { PageNavigation, PageContent } from 'components/styledComponents';
import Shimmer from 'src/components/Shimmer';

const Page: NextPage<SectionPageProps> = ({
  articles,
  sectionTree,
  sectionId,
  sectionTypeTree,
}) => {
  const router = useRouter();
  return (
    <Shimmer isLoading={router.isFallback}>
      <Row>
        <PageNavigation span="0" skip="0">
          <MobileSectionsList
            sectionTree={sectionTree}
            currentSection={sectionId}
            sectionTypeTree={sectionTypeTree}
          />
          <SectionsList
            sectionTree={sectionTree}
            currentSection={sectionId}
            sectionTypeTree={sectionTypeTree}
          />
        </PageNavigation>
        <PageContent span="0" skip="0">
          <SectionArticles
            articles={articles}
            sectionTree={sectionTree}
            currentSection={sectionId}
          />
        </PageContent>
      </Row>
    </Shimmer>
  );
};

export default Page;
